import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';
import { cn } from '@/shared/utils';
import { MARKET_TABS_ORDER, type MarketTab } from '../config/marketTabs';

const TAB_TRIGGER_CLASSNAME =
  'h-[2.8rem] flex-none rounded-[0.8rem] px-[1.2rem] py-0 medium5 transition-colors tablet:hover:bg-secondary-bg tablet:hover:text-primary data-[state=active]:bg-secondary-bg data-[state=active]:shadow-none';

type Props = {
  value: MarketTab;
  onValueChange: (value: MarketTab) => void;
  triggerClassName?: string;
};

const MarketTabs = ({ value, onValueChange, triggerClassName }: Props) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={value}
      onValueChange={nextValue => onValueChange(nextValue as MarketTab)}>
      <TabsList className="bg-transparent gap-[0.2rem] p-0 h-[2.8rem] justify-start">
        {MARKET_TABS_ORDER.map(tab => (
          <TabsTrigger
            key={tab}
            value={tab}
            className={cn(TAB_TRIGGER_CLASSNAME, triggerClassName)}>
            {t(`personalAccount.overview.market.tabs.${tab}`)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export { MarketTabs };
